import { Title } from '@restworld/ui-ds';
import 'twin.macro';

export const ModalHeader = ({ children }: { children?: React.ReactNode }) => {
  return (
    <>
      <Title standardVariant="h2" desktopOnly={true} fontWeight="semibold" textColor="black" align="center">
        {children}
      </Title>
      <Title standardVariant="h3" mobileOnly={true} fontWeight="semibold" textColor="black" align="center">
        {children}
      </Title>
    </>
  );
};

export const ModalSubHeader = ({ children }: { children?: React.ReactNode }) => (
  <Title standardVariant="h5" align="center" textColor="gray-500">
    {children}
  </Title>
);
